exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#appTemplate[data-v-699b6153]{height:100dvh;width:100dvw}#contentPart[data-v-699b6153]{height:100%;max-width:100dvw;overflow-x:hidden}#contentPart header[data-v-699b6153]{max-width:100dvw}#loginPart[data-v-699b6153]{color:#fff;height:100%}.body[data-v-699b6153]{position:relative;height:calc(100% - 80px);padding:15px}.overlay[data-v-699b6153]{position:fixed;display:none;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,78,132,.5);z-index:999}.body.active-menu .overlay[data-v-699b6153]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-699b6153","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/app.scss
// module id = 3TH9
// module chunks = 2